import { Button, Input, Modal } from 'antd';
import React from 'react';


export default class ConfirmButton extends React.Component{
    confirm = () =>  {
        Modal.confirm({
          title: 'Confirm',
          content: <div style={{ color: this.props.descriptionColor || "black" }}> {/* Change 'red' to your desired color */}
          {this.props.description}

        {this.props.showRemarks && (
            <div>
              <label style={{ fontWeight: 500 }}>Remarks:</label>
              <Input.TextArea
                rows={3}
                placeholder={this.props.remarksPlaceholder || "Enter remarks..."}
                onChange={e => this._remarks = e.target.value}
                style={{ marginTop: 6 }}
              />
            </div>
          )}

        </div>,
          okText: 'Confirm',
          cancelText: 'Cancel',
          onOk: (close) => {
            this.props.onConfirm(this._remarks || "");
            close();
          },
      
        });
      }

      render(){
        const {type ,label, loading, disabled } = this.props;
        return(
            <Button className={this.props.class} icon={this.props.icon} type={type} onClick={this.confirm} loading={loading} disabled={disabled || false}>
                {label}
            </Button>
        )
      }
}